module.exports = __webpack_public_path__ + "static/img/衣创社区公众号.77e9ec42.jpg";